// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","innerFooter":"Footer_innerFooter__s-JxO"};